import React, { useContext } from 'react';

import { Link as RouterLink } from 'react-router-dom';

import {
    Card,
    CardContent,
    CardHeader,
    Checkbox,
    Divider,
    Grid,
    Link,
    Table,
    TableBody,
    TableCell,
    TableRow,
    TextField,
    Typography
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { TipoContattoContext } from '../TipoContattoContext';


import { Field, Formik } from 'formik';
import moment from 'moment';
import * as Yup from 'yup';
import { DateTableRow, UtenteTableRow } from '../../../common';

const LinkRouter = props => <Link {...props} component={RouterLink} />;

const TipoContattoSchema = Yup.object().shape({
    nome: Yup.string().required("Il nome è un campo obbligatorio"),
    ordine: Yup.number().required("L'ordine è un campo obbligatorio"),
});

export const TipoDetails = ({
    disabled,
    formRef,
    onActionClick,
    ...props
}) => {

    const {
        state,
        setState,
    } = useContext(TipoContattoContext);

    const {
        tipoContatto,
    } = state;

    const handleOnSubmit = async (values) => {
        if (onActionClick)
            if (onActionClick)
                onActionClick("Submit", values);
    }

    return (
        <>
            <Formik
                innerRef={formRef}
                initialValues={
                    {
                        nome: tipoContatto?.nome ?? "",
                        testoGrassettoDefault: tipoContatto?.testoGrassettoDefault ?? false,
                        testoCorsivoDefault: tipoContatto?.testoCorsivoDefault ?? false,
                        testoCollegamentoDefault: tipoContatto?.testoCollegamentoDefault ?? false,
                        ordine: tipoContatto?.ordine ?? 99,
                        inizioValidita: tipoContatto?.inizioValidita ?? moment.utc([1946, 5, 2]),
                        fineValidita: tipoContatto?.fineValidita ?? null,
                    }
                }
                enableReinitialize
                validationSchema={TipoContattoSchema}
                onSubmit={handleOnSubmit}
            >
                {({
                    values,
                    handleSubmit,
                    setFieldValue,
                    errors,
                    touched,
                    setTouched,
                    handleChange,
                }) => {
                    return <form onSubmit={handleSubmit}>
                        <Grid container spacing={2} sx={{ marginTop: 2 }}>
                            <Grid item xs={12}>
                                <Card>
                                    <CardHeader
                                        sx={{
                                            color: "white",
                                            backgroundColor: "secondary.main",
                                        }}
                                        title={
                                            <Grid container alignItems="center" justify="space-between">
                                                <Grid item>
                                                    <Typography variant="h6">Informazioni</Typography>
                                                </Grid>
                                            </Grid>
                                        }
                                    />
                                    <Divider />
                                    <CardContent sx={{ padding: "0px !important" }}>
                                        <Table>
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Nome
                                                    </TableCell>
                                                    <TableCell>
                                                        <TextField
                                                            fullWidth
                                                            id="nome"
                                                            name="nome"
                                                            value={values.nome}
                                                            onChange={handleChange}
                                                            error={touched.nome && Boolean(errors.nome)}
                                                            helperText={touched.nome && errors.nome}
                                                            inputProps={{ sx: { padding: 1 } }} />
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Testo grassetto default
                                                    </TableCell>
                                                    <TableCell>
                                                        <Field
                                                            name="testoGrassettoDefault"
                                                            component={Checkbox}
                                                            onChange={e => {
                                                                setFieldValue('testoGrassettoDefault', e.target.checked);
                                                            }}
                                                            checked={values.testoGrassettoDefault}
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Testo corsivo default
                                                    </TableCell>
                                                    <TableCell>
                                                        <Field
                                                            name="testoCorsivoDefault"
                                                            component={Checkbox}
                                                            onChange={e => {
                                                                setFieldValue('testoCorsivoDefault', e.target.checked);
                                                            }}
                                                            checked={values.testoCorsivoDefault}
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Testo collegamento default
                                                    </TableCell>
                                                    <TableCell>
                                                        <Field
                                                            name="testoCollegamentoDefault"
                                                            component={Checkbox}
                                                            onChange={e => {
                                                                setFieldValue('testoCollegamentoDefault', e.target.checked);
                                                            }}
                                                            checked={values.testoCollegamentoDefault}
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Ordine
                                                    </TableCell>
                                                    <TableCell>
                                                        <TextField
                                                            fullWidth
                                                            id="ordine"
                                                            name="ordine"
                                                            value={values.ordine}
                                                            onChange={handleChange}
                                                            error={touched.ordine && Boolean(errors.ordine)}
                                                            helperText={touched.ordine && errors.ordine}
                                                            inputProps={{ sx: { padding: 1 } }} />
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Inizio validità
                                                    </TableCell>
                                                    <TableCell>
                                                        <Field
                                                            name="inizioValidita"
                                                            component={DatePicker}
                                                            onChange={value => {
                                                                if (value?.isValid)
                                                                    setFieldValue('inizioValidita', moment.utc([value.year(), value.month(), value.date()]))
                                                                else
                                                                    setFieldValue('inizioValidita', null);

                                                            }}
                                                            inputFormat="DD/MM/YYYY"
                                                            minDate={moment.utc([1946, 5, 2])}
                                                            value={values.inizioValidita}
                                                            renderInput={(params) => <TextField {...params} />}
                                                            fullWidth
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell style={{ width: "20%" }}>
                                                        Fine validità
                                                    </TableCell>
                                                    <TableCell>
                                                        <Field
                                                            name="fineValidita"
                                                            component={DatePicker}
                                                            onChange={value => {
                                                                if (value?.isValid)
                                                                    setFieldValue('fineValidita', moment.utc([value.year(), value.month(), value.date()]))
                                                                else
                                                                    setFieldValue('fineValidita', null);

                                                            }}
                                                            inputFormat="DD/MM/YYYY"
                                                            minDate={moment.utc([1946, 5, 2])}
                                                            value={values.fineValidita}
                                                            renderInput={(params) => <TextField {...params} />}
                                                            fullWidth
                                                        />
                                                    </TableCell>
                                                </TableRow>
                                                <UtenteTableRow label={'Creato da'} utenteId={tipoContatto?.creatoDa} />
                                                <DateTableRow label={'Data creazione'} stringDate={tipoContatto?.dataCreazione} />
                                                <UtenteTableRow label={'Ultima modifica da'} utenteId={tipoContatto?.aggiornatoDa} />
                                                <DateTableRow label={'Data ultima modifica'} stringDate={tipoContatto?.dataAggiornamento} />
                                            </TableBody>
                                        </Table>
                                    </CardContent>
                                </Card>
                            </Grid>
                        </Grid>
                    </form>
                }}
            </Formik>
        </>
    );
}